export enum OnboardingStep {
  InvestorPortalView = 'investor-portal-view',
  DataRoomView = 'data-room-view',
  InvestorDetails = 'investor-details',
  InvestorClassification = 'investor-classification',
  TaxDeclarations = 'tax-declarations',
  KYCOrKYB = 'kyc-or-kyb',
  DocumentSigning = 'document-signing',
  CommitmentConfirmation = 'commitment-confirmation',
}

export enum OnboardingStepStatus {
  Requested = 'requested',
  StartedByInvestor = 'started-by-investor',
  InReview = 'in-review',
  Completed = 'completed',
  Disabled = 'disabled',
  MoreInformationRequested = 'more-information-requested',
}
